/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { createContext, useContext } from "react";

export interface TabsContextValue {
	activeIndex?: number;
	onIndexChange?: (index: number) => void;
	canToggleTabs?: boolean;
	size?: "sm" | "md" | "lg";
	activeVariant?: string;
	inactiveVariant?: string;
	hasTabsList?: boolean;
	setHasTabsList?: (value: boolean) => void;
}

export const TabsContext = createContext<TabsContextValue | null>(null);

export const useTabsContext = (): TabsContextValue => {
	const context = useContext(TabsContext);
	if (!context) {
		throw new Error("Tabs components must be used within a CosmosTabs provider");
	}
	return context;
};
